import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_TALON_LOG = 'talonLogFilters'

const TalonLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_TALON_LOG)

  const statusOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'status', [
        'PENDING',
        'PROCESSING',
        'SUCCESS',
        'FAILED',
      ]),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <FilterTextInput
        label="Customer Integration ID"
        value={filters.customerIntegrationId || ''}
        onApply={(value) => setField('customerIntegrationId', value)}
      />

      <FilterTextInput
        label="Session Integration ID"
        value={filters.sessionIntegrationId || ''}
        onApply={(value) => setField('sessionIntegrationId', value)}
      />

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default TalonLogFilterForm
